"use strict";

import { LoginFormConstants } from 'Constants/Login/LoginFormConstants';
import { AppDispatcher } from 'Dispatcher';
/**
 * @param {string} login
 * @param {string} pass
 */

export function login(login, pass) {
  AppDispatcher.dispatch({
    actionType: LoginFormConstants.DO_LOGIN,
    login: login,
    password: pass
  });
}